export const STARTING = 'STARTING'
export const EXECUTING = 'EXECUTING'
export const STOPPED = 'STOPPED'
export const FULFILLED = 'FULFILLED'
